function buildRing({ containerId, radius, itemSize, itemCount }) {
  const container = document.getElementById(containerId);
  if (!container) return;

    console.log(containerId, 'radius:', radius);


  const diameter = radius * 2;
  container.style.width = diameter + 'px';
  container.style.height = diameter + 'px';

  for (let i = 0; i < itemCount; i++) {
    const angle = (360 / itemCount) * i;
    const rad = (angle * Math.PI) / 180;
    const pointX = radius + radius * Math.cos(rad);
    const pointY = radius + radius * Math.sin(rad);

    const el = document.createElement('div');
    el.style.cssText = `
      position: absolute;
      left: ${pointX - itemSize / 2}px;
      top: ${pointY - itemSize / 2}px;
      width: ${itemSize}px;
      height: ${itemSize}px;
      background: #808FA3;
      border-radius: 50%;
    `;
    container.appendChild(el);
  }
}

function initItems() {
  const globe = document.getElementById('globeOuter');
  const ring = document.getElementById('ringOuter');
  if (!globe || !ring) return;

  const items = globe.querySelectorAll('.Process__item');
  if (!items.length) return;

  const count = items.length;
  const radius = 185;
  const baseAngles = Array.from(items).map((_, i) => (360 / count) * i - 90);

  const globeRect = globe.getBoundingClientRect();
  const ringRect = ring.getBoundingClientRect();

  // środek ringu względem globe
const cx = globe.offsetWidth / 2;
const cy = globe.offsetHeight / 2;

console.log('globe:', globe.offsetWidth, globe.offsetHeight);
console.log('cx/cy:', globe.offsetWidth / 2, globe.offsetHeight / 2);

  items.forEach(item => {
    item.style.position = 'absolute';
    item.style.left = `${cx}px`;
    item.style.top = `${cy}px`;
  });

  function getRingAngle() {
    const matrix = new DOMMatrix(window.getComputedStyle(ring).transform);
    return Math.atan2(matrix.m12, matrix.m11) * (180 / Math.PI);
  }

  function update() {
    const ringAngle = getRingAngle();

    items.forEach((item, i) => {
      const angle = baseAngles[i] + ringAngle;
      const rad = (angle * Math.PI) / 180;
      const x = radius * Math.cos(rad);
      const y = radius * Math.sin(rad);
      item.style.transform = `translate(calc(-50% + ${x}px), calc(-50% + ${y}px))`;
    });

    requestAnimationFrame(update);
  }

  requestAnimationFrame(update);

  items.forEach(item => {
    item.addEventListener('mouseenter', () => {
      ring.style.animationPlayState = 'paused';
    });
    item.addEventListener('mouseleave', () => {
      ring.style.animationPlayState = 'running';
    });
  });
}

if (document.querySelector('.Process')) {
  buildRing({ containerId: 'ringInner', radius: 130, itemSize: 2, itemCount: 36 });
  buildRing({ containerId: 'ringOuter', radius: 185, itemSize: 2, itemCount: 48 });
  initItems();
}